module.exports = __webpack_public_path__ + "static/media/cala.32fe9310.png";